/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "添加"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "全部移除"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var zhCN = Object.assign(TranslationProviderComponent, {
  translations
});

export { zhCN as z };
//# sourceMappingURL=zh-CN-B5d6GPwL.js.map
